module.exports = __webpack_public_path__ + "img/android.f1cc43f8.png";